import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { RoleEnum } from '@affiliation/enums';
import { ChannelApi, TeamApi, SellersApi } from '~/api';

export var state = function state() {
	return {
		items: [],
		teamForAdmin: [],
		idTeam: '',
		dataChannel: {}
	};
};

export var actions = {
	list: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var rootState = _ref.rootState,
			    commit = _ref.commit;
			var channels;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return new ChannelApi(this.$axios).getChannelsManagement({
								idBoss: rootState.user.userId,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 2:
							channels = _context.sent;

							commit('setList', channels);

						case 4:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function list(_x) {
			return _ref2.apply(this, arguments);
		}

		return list;
	}(),
	loadTeams: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, idChannel) {
			var rootState = _ref3.rootState,
			    commit = _ref3.commit;
			var teams;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							_context2.next = 2;
							return new TeamApi(this.$axios).getTeamManagement({
								idChannel: idChannel,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 2:
							teams = _context2.sent;

							commit('setTeamByChannel', { idChannel: idChannel, teams: teams });
							return _context2.abrupt('return', teams);

						case 5:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function loadTeams(_x2, _x3) {
			return _ref4.apply(this, arguments);
		}

		return loadTeams;
	}(),
	editChannel: function () {
		var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5, data) {
			var state = _ref5.state,
			    rootState = _ref5.rootState;
			var idBossConditional;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							idBossConditional = rootState.user.roleId === 2 ? rootState.user.userId : data.idBoss;
							//let isActiveConditional = rootState.user.roleId === 2 ? false : data.isActive

							_context3.next = 3;
							return new ChannelApi(this.$axios).editChannel({
								idChannel: data.idChannel,
								name: data.name,
								idBoss: idBossConditional,
								isActive: data.isActive,
								virtualProducts: data.virtualProducts
							});

						case 3:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function editChannel(_x4, _x5) {
			return _ref6.apply(this, arguments);
		}

		return editChannel;
	}(),
	findChannelForEdit: function () {
		var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7, data) {
			var state = _ref7.state,
			    commit = _ref7.commit;
			var response;
			return _regeneratorRuntime.wrap(function _callee4$(_context4) {
				while (1) {
					switch (_context4.prev = _context4.next) {
						case 0:
							_context4.next = 2;
							return new ChannelApi(this.$axios).findChannelForEdit({
								idChannel: data
							});

						case 2:
							response = _context4.sent;

							commit('setDataChannel', response);
							return _context4.abrupt('return', response);

						case 5:
						case 'end':
							return _context4.stop();
					}
				}
			}, _callee4, this);
		}));

		function findChannelForEdit(_x6, _x7) {
			return _ref8.apply(this, arguments);
		}

		return findChannelForEdit;
	}(),
	createdNewChannel: function () {
		var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref9, data) {
			var state = _ref9.state;
			return _regeneratorRuntime.wrap(function _callee5$(_context5) {
				while (1) {
					switch (_context5.prev = _context5.next) {
						case 0:
							_context5.next = 2;
							return new ChannelApi(this.$axios).createdNewChannel({
								name: data.name,
								virtualProducts: data.virtualProducts,
								idBoss: data.idBoss,
								isActive: data.isActive
							});

						case 2:
						case 'end':
							return _context5.stop();
					}
				}
			}, _callee5, this);
		}));

		function createdNewChannel(_x8, _x9) {
			return _ref10.apply(this, arguments);
		}

		return createdNewChannel;
	}(),
	loadListOfTeamsForAdmin: function () {
		var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref11, idTeam) {
			var commit = _ref11.commit,
			    rootState = _ref11.rootState;
			var teams;
			return _regeneratorRuntime.wrap(function _callee6$(_context6) {
				while (1) {
					switch (_context6.prev = _context6.next) {
						case 0:
							_context6.next = 2;
							return new TeamApi(this.$axios).getTeamManagement({
								idChannel: idTeam,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 2:
							teams = _context6.sent;


							commit('setListOfTeam', teams);
							return _context6.abrupt('return', teams);

						case 5:
						case 'end':
							return _context6.stop();
					}
				}
			}, _callee6, this);
		}));

		function loadListOfTeamsForAdmin(_x10, _x11) {
			return _ref12.apply(this, arguments);
		}

		return loadListOfTeamsForAdmin;
	}(),

	// API para probar llegada de datos
	loadItemsInListOfTeamsForAdmin: function () {
		var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref13, idTeam) {
			var rootState = _ref13.rootState,
			    commit = _ref13.commit;
			var teams;
			return _regeneratorRuntime.wrap(function _callee7$(_context7) {
				while (1) {
					switch (_context7.prev = _context7.next) {
						case 0:
							_context7.next = 2;
							return new SellersApi(this.$axios).getSellersManagement({
								idTeam: idTeam || 0,
								idRole: rootState.user.roleId,
								term: ''
							});

						case 2:
							teams = _context7.sent;

							commit('setLoadItemsInListOfTeam', { idTeam: idTeam, teams: teams });
							console.warn(teams);
							return _context7.abrupt('return', teams);

						case 6:
						case 'end':
							return _context7.stop();
					}
				}
			}, _callee7, this);
		}));

		function loadItemsInListOfTeamsForAdmin(_x12, _x13) {
			return _ref14.apply(this, arguments);
		}

		return loadItemsInListOfTeamsForAdmin;
	}(),
	editChannelManagement: function () {
		var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref15, data) {
			var state = _ref15.state,
			    rootState = _ref15.rootState;
			return _regeneratorRuntime.wrap(function _callee8$(_context8) {
				while (1) {
					switch (_context8.prev = _context8.next) {
						case 0:
							_context8.next = 2;
							return new ChannelApi(this.$axios).editChannelManagement({
								idChannel: data.idChannel,
								idBoss: data.idBoss,
								active: data.isActive
							});

						case 2:
						case 'end':
							return _context8.stop();
					}
				}
			}, _callee8, this);
		}));

		function editChannelManagement(_x14, _x15) {
			return _ref16.apply(this, arguments);
		}

		return editChannelManagement;
	}(),
	validNewChannelName: function () {
		var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref17, data) {
			var state = _ref17.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee9$(_context9) {
				while (1) {
					switch (_context9.prev = _context9.next) {
						case 0:
							_context9.next = 2;
							return new ChannelApi(this.$axios).validNewChannelName({
								name: data.name
							});

						case 2:
							response = _context9.sent;
							return _context9.abrupt('return', response);

						case 4:
						case 'end':
							return _context9.stop();
					}
				}
			}, _callee9, this);
		}));

		function validNewChannelName(_x16, _x17) {
			return _ref18.apply(this, arguments);
		}

		return validNewChannelName;
	}(),
	validEditChannel: function () {
		var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref19, data) {
			var state = _ref19.state;
			var response;
			return _regeneratorRuntime.wrap(function _callee10$(_context10) {
				while (1) {
					switch (_context10.prev = _context10.next) {
						case 0:
							_context10.next = 2;
							return new ChannelApi(this.$axios).validEditChannel({
								idChannel: data.idChannel,
								name: data.name
							});

						case 2:
							response = _context10.sent;
							return _context10.abrupt('return', response);

						case 4:
						case 'end':
							return _context10.stop();
					}
				}
			}, _callee10, this);
		}));

		function validEditChannel(_x18, _x19) {
			return _ref20.apply(this, arguments);
		}

		return validEditChannel;
	}()
};

export var mutations = {
	setList: function setList(state, items) {
		state.items = items.map(function (item) {
			return {
				name: item.Name,
				value: item.IdChannel,
				active: item.IsActive === 0 ? false : true,
				channels: item.Teams,
				items: [],
				type: 'Canales'
			};
		});
	},
	setTeamByChannel: function setTeamByChannel(state, _ref21) {
		var idChannel = _ref21.idChannel,
		    teams = _ref21.teams;

		for (var i = 0; i < state.items.length; i++) {
			if (state.items[i].value === idChannel) {
				state.items[i].items = teams.map(function (item) {
					return {
						name: item.Name,
						value: item.IdTeam,
						active: item.IsActive === 0 ? false : true
					};
				});
				break;
			}
		}
	},
	setListOfTeam: function setListOfTeam(state, items) {
		state.teamForAdmin = items.map(function (item) {
			return {
				name: item.Name,
				value: item.IdTeam,
				active: item.IsActive === 0 ? false : true,
				channels: item.Sellers,
				items: [],
				type: 'Canales'
			};
		});
	},
	setLoadItemsInListOfTeam: function setLoadItemsInListOfTeam(state, _ref22) {
		var idTeam = _ref22.idTeam,
		    teams = _ref22.teams;

		for (var i = 0; i < state.teamForAdmin.length; i++) {
			if (state.teamForAdmin[i].value === idTeam) {
				state.teamForAdmin[i].items = teams.map(function (item) {
					var conditional = item.Role === 'Supervisor' ? true : false;
					return {
						firstName: item.Firstname,
						lastName: item.Lastname,
						name: item.Firstname + ' ' + item.Lastname,
						boss: item.Boss,
						active: item.IsActive === 0 ? false : true,
						role: item.Role,
						value: item.IdUser,
						supervisor: conditional,
						user: item.Username,
						phone: item.Cellphone,
						documentType: item.DocumentType,
						documentNumber: item.DocumentNumber,
						team: item.Team,
						email: item.Email,
						channel: item.ChannelName,
						subchannel: item.SubChannelName,
						groupChannelName: item.GroupChannelName
					};
				});
				break;
			}
		}
	},
	updateStatusTeam: function updateStatusTeam(state, data) {
		for (var i = 0; i < state.items.length; i++) {
			// encontrar el canal
			if (state.items[i].value === data.idBoss) {
				// encontrar el equipo
				for (var j = 0; j < state.items[i].items.length; j++) {
					if (state.items[i].items[j].value === data.val.value) {
						state.items[i].items[j].active = data.val.status;
					}
				}
			}
		}
	},
	updateStatusSeller: function updateStatusSeller(state, data) {
		for (var i = 0; i < state.teamForAdmin.length; i++) {
			// encontrar el canal
			if (state.teamForAdmin[i].value === data.idBoss) {
				// encontrar el equipo
				for (var j = 0; j < state.teamForAdmin[i].items.length; j++) {
					if (state.teamForAdmin[i].items[j].value === data.val.value) {
						state.teamForAdmin[i].items[j].active = data.val.status;
					}
				}
			}
		}
	},
	setIdTeam: function setIdTeam(state, data) {
		state.idTeam = data;
	},
	updateSetListOfTeamForAdmin: function updateSetListOfTeamForAdmin(state, data) {
		for (var i = 0; i < state.teamForAdmin.length; i++) {
			if (state.teamForAdmin[i].value == data) {
				var response = Number(state.teamForAdmin[i].channels) + 1;
				return state.teamForAdmin[i].channels = String(response);
			}
		}
	},
	updateTeamsForBoss: function updateTeamsForBoss(state, data) {
		for (var i = 0; i < state.items.length; i++) {
			if (state.items[i].value == data) {
				var response = Number(state.items[i].channels) + 1;
				return state.items[i].channels = String(response);
			}
		}
	},
	setDataChannel: function setDataChannel(state, data) {
		state.dataChannel = data;
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/store/channel.js
// module id = ./src/store/channel.js
// module chunks = 34